import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-input-comment-tribe',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './input-comment-tribe.component.html',
  styleUrls: ['./input-comment-tribe.component.scss'],
})
export class InputCommentTribeComponent {
  @Output() onPublishComment = new EventEmitter<string>();
  comment: string = '';
  @Input() buttonText: string = 'Publicar';
  @Input() urlImageProfileLogued:string | null = null;
  lengthComment: number = 0;

  constructor() {
  }

  onChange(e: any) {
    // console.log(e.target.value);
    this.comment = e.target.value;
    this.lengthComment = this.comment.length;

  }

  onPublish() {
    if(this.comment===''){return}
    this.onPublishComment.emit(this.comment);
    this.comment = '';
  }
}
